// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal__overlay___QBrD7"};